module.exports = __webpack_public_path__ + "img/vipbanner.686ec589.jpg";